module.exports = __webpack_public_path__ + "img/recommendation_image.4a0cc822.jpg";